v<template>
  <div>
    <b-field grouped group-multiline>
        <b-field label="Type">
            <b-select
              expanded
              :placeholder="selectPlaceholder"
              message="Please select an item in the list."
              v-model="type"
              required
            >
                <option
                    v-for="type in shareholderTypes"
                    :value="type.value"
                    :key="type.value">
                    {{ type.text }}
                </option>
            </b-select>
        </b-field>
        <b-field label="Name" expanded>
            <b-input type="text" required
              v-model.trim="name"
            />
        </b-field>
        <b-field label="Number of shareholders" v-if="type === 'company'">
          <b-input type="number" min="0" max="99" required
            v-model.number="shareholdersNumber"
          />
        </b-field>
        <b-field :label="sharesNumberLabel" v-if="!isTrust">
          <b-input type="number" min="0" max="100" step="0.01" required
            placeholder="i.e. 49.99"
            v-model="sharesNumber"
            v-if="isSharesPercentage"
          />
          <b-input type="number" min="0" required
            v-model="sharesNumber"
            v-else
          />
        </b-field>
        <b-field label="Calculated %" v-if="!isSharesPercentage">
          <b-input type="number" disabled
            :value="sharesPercenatageCalc"
          />
        </b-field>
        <b-field label="Is voting?" v-if="!isTrust">
          <b-checkbox v-model="isShareVoting"/>
        </b-field>
    </b-field>
    <hr>
  </div>
</template>

<script>
import uuid from 'uuid'

export default {
  name: 'ShareholdersRow',
  props: [
    'idx',
    'isTrust',
    'isSharesPercentage',
    'totalShares'
  ],
  data () {
    return {
      rowId: uuid.v4(),
      type: null,
      name: null,
      sharesNumber: null,
      isShareVoting: true,
      localIsSharesPercentage: this.isSharesPercentage,
      localTotalShares: this.totalShares,
      shareholdersNumber: null,
      shareholderTypes: [
        {
          value: 'individual_shareholder',
          text: 'Individual'
        },
        {
          value: 'company',
          text: 'Company'
        }
      ]
    }
  },
  watch: {
    type () {
      this.onShareholdersChange()
    },
    name () {
      this.onShareholdersChange()
    },
    sharesNumber () {
      this.onShareholdersChange()
    },
    isShareVoting () {
      this.onShareholdersChange()
    },
    shareholdersNumber () {
      this.onShareholdersChange()
    },
    isSharesPercentage () {
      this.localIsSharesPercentage = this.isSharesPercentage
    },
    totalShares () {
      this.localTotalShares = this.totalShares
      this.onShareholdersChange()
    }
  },
  computed: {
    shareholder () {
      return {
        id: this.rowId,
        name: this.name,
        sharesNumber: this.sharesNumber,
        sharesPercentage: this.localIsSharesPercentage ? this.sharesNumber : this.sharesPercenatageCalc,
        isShareVoting: this.isShareVoting,
        type: this.type
      }
    },
    selectPlaceholder () {
      const entityString = this.isTrust ? 'trustee' : 'shareholder'
      return `Select ${entityString} type`
    },
    sharesNumberLabel () {
      const sharesNumberUnit = this.localIsSharesPercentage ? '%' : 'units'
      return `Number of shares, ${sharesNumberUnit}`
    },
    sharesPercenatageCalc () {
      if (this.localIsSharesPercentage) return this.sharesNumber
      if (this.localTotalShares <= 0) return null
      return (100 * this.sharesNumber / this.localTotalShares).toFixed(2)
    }
  },
  methods: {
    onShareholdersChange () {
      this.$emit('shareholders-change',
        this.rowId,
        this.idx,
        this.shareholder,
        this.shareholdersNumber
      )
    }
  }
}
</script>

<style scoped>

</style>
